// @ts-nocheck
import styled, { keyframes } from 'styled-components'
import { getDashColor } from '../../styles'

export const Container = styled.div`
  width: 100%;
`

export const ContainerCard = styled.div`
  width: 100%;
  border-radius: 15px;
  background: #fff;
  @media (max-width: 806px) {
    margin-top: 0px;
  }
`

export const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px;
  flex-wrap: wrap;
  @media (max-width: 806px) {
    padding: 15px 15px 0px 15px;
  }
`

export const TitleContainerMobile = styled.div`
  display: none;
  @media (max-width: 806px) {
    display: flex;
    margin-bottom: 1rem;
  }
`

export const TitleTextMobile = styled.h1`
  font-size: 16px;
  font-weight: 600;
`
export const TitleTextGeneralGoals = styled.h1`
  color: '#212D45';
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  width: 200px;
  @media (max-width: 720px) {
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 19.6px;
    margin-bottom: 14px;
  }
`

export const TitleTextDailyGoals = styled.h1`
  color: #212d45;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  @media (max-width: 720px) {
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 19.6px;
    margin-bottom: 14px;
  }
`

export const SelectContainer = styled.div`
  display: flex;
`

export const SelectIndividualContainer = styled.div`
  padding: 16px;
  border: 1px solid #b7b7b7;
  border-radius: 5px;
  width: 16.5rem;
`

export const CloseButton = styled.button`
  border: none;
  align-self: center;
  justify-self: center;
  background-color: transparent;
  cursor: pointer;
  @media (max-width: 600px) {
    margin-left: 20px;
  }
`

export const HeaderModalContainer = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #d4e3e9;
  padding: 0px 0px 20px 0px;
  gap: 30px;
`

export const HeaderModalIconContainer = styled.div`
  @media (max-width: 720px) {
    display: none;
  }
`

export const TitleModalContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const ButtonModalContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 25px;
`

export const TicketTypeSelect = styled.select`
  display: flex;
  width: 100%;
  border: none;
  background: #fff;
  padding: 0px;
  outline: none;
  cursor: pointer;
`

export const MainContainer = styled.div`
  justify-content: space-between;
  gap: 30px;
  padding: 0px 30px 30px 30px;
  @media (max-width: 1368px) {
    flex-direction: column;
  }
  @media (max-width: 806px) {
    padding: 15px;
  }
`

export const MainDailyGoalsContainer = styled.div`
  justify-content: space-between;
  gap: 30px;
  padding: 0px 30px 30px 30px;
  @media (max-width: 1368px) {
    flex-direction: column;
  }
  @media (max-width: 806px) {
    padding: 15px;
  }
`

export const ContainerButtonAndInput = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
`

export const SubTitleForm = styled.a`
  margin-top: 8px;
  font-weight: 400;
  font-size: 13px;
  color: #121926;
  @media (max-width: 580px) {
    font-size: 10px;
  }
`

export const ContainerForm = styled.div`
  display: flex;
  flex-direction: column;
`

export const Input = styled.input`
  display: flex;
  align-items: center;
  height: 51px;
  padding-left: 15px;
  font-weight: 400;
  font-size: 13px;
  border: 1px solid #dedede;
  border-radius: 5px;
  outline: none;
  margin-top: 12px;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`

export const LabelInputForm = styled.a`
  font-weight: bold;
  font-size: 18px;
  color: #121926;
`

export const DetailsContainer = styled.div`
  display: flex;
  margin-bottom: 56px;
  gap: 17px;
  @media (max-width: 1450px) {
    flex-wrap: wrap;
  }
  @media (max-width: 1420px) {
    justify-content: center;
  }
`

export const DailyGoalsTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 35px;
  @media (max-width: 720px) {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
`

export const ChartContainer = styled.div`
  padding: 30px;
  border: 1px solid #b7b7b7;
  border-radius: 5px;
  width: 100%;
  height: 375px;
  position: relative;
  @media (max-width: 806px) {
    padding: 15px;
  }
  @media (max-width: 1368px) {
    max-width: 100%;
  }
`

export const LegendChartContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
`

export const LegendChart = styled.div`
  display: flex;
`

export const LegendChartText = styled.h1`
  font-size: 10px;
  font-weight: 400;
  color: #000;
  &:before {
    content: '';
    width: 12px;
    height: 8px;
    background-color: #121926;
    display: inline-block;
    margin-right: 4px;
  }
`

export const LegendChartText1 = styled.h1`
  font-size: 10px;
  font-weight: 400;
  color: #000;
  &:before {
    content: '';
    width: 12px;
    height: 8px;
    background-color: #32d583;
    display: inline-block;
    margin-right: 4px;
  }
`

export const LegendChartText2 = styled.h1`
  font-size: 10px;
  font-weight: 400;
  color: #000;
  &:before {
    content: '';
    width: 12px;
    height: 8px;
    background-color: #e60d1e;
    display: inline-block;
    margin-right: 4px;
  }
`

export const BlurredChartContainer = styled.div`
  filter: blur(40px);
  pointer-events: none;
`

export const BlurChartContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  width: 100%;
  height: 35%;
  padding: 50px;
`

export const BlurMainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`

export const BlurTitle = styled.h4`
  color: #121926;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 35.2px;
  @media (max-width: 575px) {
    color: #121926;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
  }
`

export const BlurSubtitle = styled.p`
  color: #121926;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22.4px; /* 140% */
  @media (max-width: 575px) {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`

export const ContainerDatePicker = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 17px;
  border: 1px solid var(--gray-100);
  border-radius: 5px;
  width: 100%;
  max-width: 227px;
  height: 50px;
  @media (max-width: 900px) {
    width: 100%;
    max-width: 41px;
    height: 39px;
    background-color: #212d45;
  }
`

export const CustomInput = styled.input`
  display: none;
`

export const ModalButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 480px;
  @media (max-width: 1080px) {
    margin-top: 480px;
  }
  @media (max-width: 580px) {
    margin-top: 310px;
  }
`

export const ContainerListGoals = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 430px;
  border-top: 1px solid #d4e3e9;
  @media (max-width: 1080px) {
    margin-top: 480px;
  }
  @media (max-width: 580px) {
    margin-top: 310px;
  }
`

export const ListGoalTitle = styled.a`
  font-size: 14px;
  font-weight: 400;
  color: #a8a8a8;
  margin-top: 30px;
`

export const ButtonAddAndInputModalContainer = styled.div`
  display: flex;
  gap: 10px;
  border-top: 1px solid #d4e3e9;
  padding: 30px 0px 0px 0px;
`

export const SetGoalsQuantityContainerModal = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 25px 0px 0px 0px;
`

export const SetGoalsQuantityContainerTextModal = styled.p`
  color: #a8a8a8;
`

export const DataSetGoalsQuantityContainerModal = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 25px 0px 20px 0px;
`

export const DataSetGoalsQuantityTextModal = styled.p`
  display: flex;
  font-weight: 600;
  font-size: 14px;
  color: #4c5159;
`

export const IconGarbageContainer = styled.div`
  display: flex;
  padding-left: 24px;
`

export const ModalSetGoalsContainer = styled.div``

export const CalendarContainer = styled.div`
  display: flex;
  .react-datepicker__day-name,
  .react-datepicker__day,
  .react-datepicker__time-name {
    font-size: 1rem;
    font-weight: 700;
    color: #000;
    display: inline-block;
    width: 51px;
    height: 51px;
    line-height: 47px;
    text-align: center;
    margin: 0.166rem;
    border: 1px solid #d4e3e9;
    border-radius: 20px;
    @media (max-width: 580px) {
      width: 31px;
      height: 31px;
      border-radius: 12px;
      line-height: 31px;
      font-size: 0.8rem;
    }
  }

  .react-datepicker__day-name {
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    color: #9cacb7;
    border: none;
    @media (max-width: 580px) {
      font-size: 0.8rem;
    }
  }

  .react-datepicker__day--outside-month {
    visibility: hidden;
  }

  .react-datepicker__day-names,
  .react-datepicker__week {
    white-space: nowrap;
    border: none;
  }

  .react-datepicker__current-month,
  .react-datepicker-time__header,
  .react-datepicker-year-header {
    margin-top: -7px;
    color: #000;
    font-weight: bold;
    font-size: 0.944rem;
  }

  .react-datepicker__navigation {
    // Container que segura as flechas laterais para passar os meses
    display: flex;
    text-align: center;
    cursor: pointer;
    position: absolute;
    top: 2px;
    border: 1px solid #d4e3e9;
    border-radius: 20px;
  }

  .react-datepicker__day-names,
  .react-datepicker__week {
    white-space: nowrap;
    border: none;
    margin-left: 9px;
    @media (max-width: 1080px) {
      margin-left: 15px;
    }
    @media (max-width: 720px) {
      margin-left: 10px;
    }
    @media (max-width: 580px) {
      margin-left: 50px;
    }
    @media (max-width: 480px) {
      margin-left: 0px;
    }
    @media (max-width: 410px) {
      margin-left: 0;
    }
  }

  .react-datepicker__day-names {
    margin-top: 10px;
  }

  .react-datepicker__week {
  }

  .react-datepicker__navigation-icon--next::before {
    // seta direita para passar meses
    transform: rotate(45deg);
    margin-left: 1px;
  }

  .react-datepicker__navigation-icon--previous::before {
    // seta esquerda para passar meses
    transform: rotate(225deg);
    margin-right: 1px;
  }

  .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-year-read-view--down-arrow,
  .react-datepicker__navigation-icon::before {
    // muda a cor das duas setas
    border-color: #000;
    border-radius: 2px;
    margin-top: 0;
  }

  .react-datepicker__day.react-datepicker__day--keyboard-selected {
    //representa a data de hoje ja selecionada por default
    border-radius: 20px;
    background-color: #90b5d2;
    color: var(--black);
    @media (max-width: 580px) {
      border-radius: 12px;
    }
  }

  .react-datepicker-popper {
    width: 100%;
  }

  .react-datepicker__day--in-range {
    background-color: #90b5d2;
  }

  .react-datepicker {
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.189);
    border: none !important;
  }

  .react-datepicker__header {
    border-bottom: solid 5px var(--light) !important;
    background: white !important;
  }

  .react-datepicker__day.react-datepicker__day--selected {
    border: 1px solid #e60d1e;
    border-radius: 20px;
    background-color: #e60d1e;
    color: white;
  }

  .react-datepicker__day--highlighted {
    background-color: rgb(33, 45, 69);
    color: #fff;
  }
`

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`

export const LoadingSpinner = styled.div`
  border: 4px solid #fff;
  border-top: 4px solid ${getDashColor('SECONDARY_BLUE_06', 'SECONDARY_COLOR')};
  border-radius: 50%;
  width: 36px;
  height: 36px;
  animation: ${rotate} 2s linear infinite;
`

LoadingSpinner.defaultProps = {
  className: 'loading-spinner',
}

export const MessageAddOrEditGoalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 410px;
  padding: 30px 30px 30px 0px;
  border-top: 1px solid #d4e3e9;
  @media (max-width: 580px) {
    margin-top: 340px;
  }
`

export const MessageAddOrEditGoalText = styled.p`
  font-size: 14px;
  font-weight: 400;

  @media (max-width: 580px) {
    font-size: 9px;
  }
`

export const SetGoalsModalInput = styled.input`
  width: 100%;
  height: 51px;
  border-radius: 5px;
  border: 1px solid #d4e3e9;
  outline: none;
  color: #000;
  font-size: 14px;
  font-weight: 400;
  padding: 10px;
`

export const MetaGeralContainer = styled.div`
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  align-items: center;
  width: 100%;
  @media (max-width: 575px) {
    align-items: flex-start;
    flex-direction: column;
  }
`

export const SetGoalButtonContainer = styled.div`
  width: 100%;
  max-width: 270px;
  @media (max-width: 575px) {
    max-width: 100%;
  }
`

export const SubTextContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: flex-end;
  width: 100%;
`

export const BlurSubtitleMetaGeral = styled.p`
  color: black;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: center;
  white-space: nowrap;
  margin-right: 15px;
  margin-right: 14px;

  @media (max-width: 575px) {
    font-size: 9px;
    white-space: initial;
    line-height: 12px;
    margin-bottom: 10px;
    text-align: left;
  }
`
